import Fuse from "fuse.js";

function getExternalAmountOperatorCountry(operator) {
    if (!operator || typeof operator !== 'string') {
        return false
    }

    const legacyMatch = operator.match(/^[^_]+_Donor\d+_.+_([A-Z]{2})$/)
    if (legacyMatch) {
        return legacyMatch[1]
    }

    const directMatch = operator.match(/^Donor[^_]*_([A-Z]{2})$/)
    if (directMatch) {
        return directMatch[1]
    }

    return false
}

window.ORDER_PAGE_CATALOG_HELPERS = {
    /* TEMPORARY SFR_FR / FR / WhatsApp VOICE OVERRIDE — REMOVE START */
    isWhatsappSfrVoiceOperator(operator, country, service) {
        return this.typeNumbers === this.typesNumbers.SMS.type &&
            operator === 'SFR_FR' && country === 'FR' && service === 'opt20'
    },
    /* TEMPORARY SFR_FR / FR / WhatsApp VOICE OVERRIDE — REMOVE END */

    getCurrentVoice() {
        if (!this.isUserLoggedIn) {
            return 0
        }

        if (this.typeNumbers && this.typesNumbers && this.typesNumbers[this.typeNumbers]) {
            return this.typesNumbers[this.typeNumbers].voice
        }

        return 0
    },

    getPriceCacheKey(key) {
        return `${key}__voice_${this.getCurrentVoice()}`
    },

    normalizePrice(price) {
        if (price === null || price === '' || price === undefined) {
            return null
        }

        const numericPrice = Number(price)

        if (!numericPrice || Number.isNaN(numericPrice) || numericPrice <= 0) {
            return null
        }

        return numericPrice
    },

    isPriceAvailable(opt, cCode, operator = false) {
        return this.getDisplayPrice(opt, cCode, operator) !== null
    },

    getDisplayPrice(opt, cCode, operator = false) {
        if (!opt || !cCode) {
            return null
        }

        if (operator) {
            if (operator == 'Total_' + cCode) {
                return this.normalizePrice(this.getPriceTotal(opt, cCode))
            }

            const operators = this.getPriceOperators(opt, cCode)
            // CHANGE
            const operatorPrice = this.normalizePrice(operators[operator])

            if (operatorPrice !== null) {
                return operatorPrice
            }

            if (this.isExternalAmountOperator(operator, cCode)) {
                return this.getPriceTotal(opt, cCode)
            }
            // END CHANGE

            return null
        }

        return this.normalizePrice(this.getCheapestOperator(opt, cCode))
    },

    getPriceOperators(opt, cCode) {
        if (!opt || !cCode) {
            return {}
        }

        const byCountry = this.pricesByCountry && this.pricesByCountry[cCode] && this.pricesByCountry[cCode][opt]
        const byService = this.pricesByService && this.pricesByService[opt] && this.pricesByService[opt][cCode]

        // Use the response belonging to the active selection direction. Otherwise
        // a stale country response can hide newly loaded service-side prices.
        if (this.reverseMode) {
            return byCountry || byService || {}
        }

        return byService || byCountry || {}
    },

    getPriceTotal(opt, cCode) {
        if (!opt || !cCode) {
            return null
        }

        const operators = this.getPriceOperators(opt, cCode)
        const totalOperator = 'Total_' + cCode

        if (Object.prototype.hasOwnProperty.call(operators, totalOperator)) {
            return this.normalizePrice(operators[totalOperator])
        }

        return this.getCheapestOperator(opt, cCode)
    },

    getCheapestOperator(opt, cCode) {
        if (!opt || !cCode) {
            return 0
        }

        let operators = {}
        const operatorsAmount = this.getAmountOperators(opt, cCode)

        operators = this.getPriceOperators(opt, cCode)

        const availableOperatorCount = this.getAvailableCountOperators(opt, cCode)
        let cheapPrice = null

        for (const operator in operators) {
            const price = this.normalizePrice(operators[operator])

            if (price === null) {
                continue
            }

            if (
                availableOperatorCount && availableOperatorCount > 0 &&
                operatorsAmount && Object.values(operatorsAmount).length > 0
            ) {
                if (operatorsAmount.hasOwnProperty(operator) && operatorsAmount[operator] > 0) {
                    cheapPrice = !cheapPrice || price < cheapPrice ? price : cheapPrice
                }
            } else {
                cheapPrice = !cheapPrice || price < cheapPrice ? price : cheapPrice
            }
        }

        if (!cheapPrice || isNaN(Number(cheapPrice))) {
            return 0
        }

        return cheapPrice.toFixed(2)
    },

    getAmountOperators(opt, cCode) {
        if (!opt || !cCode) {
            return {}
        }

        const byCountry = this.amountByCountry && this.amountByCountry[cCode] && this.amountByCountry[cCode][opt]
        const byService = this.amountByService && this.amountByService[opt] && this.amountByService[opt][cCode]

        // Keep amount source in sync with the selected direction, just like prices.
        return this.reverseMode ? (byCountry || byService || {}) : (byService || byCountry || {})
    },

    getOperatorRating(opt, cCode, operator) {
        if (!opt || !cCode || !operator) {
            return null
        }

        const byCountry = this.operatorRatingsByCountry && this.operatorRatingsByCountry[cCode] && this.operatorRatingsByCountry[cCode][opt]
        const byService = this.operatorRatingsByService && this.operatorRatingsByService[opt] && this.operatorRatingsByService[opt][cCode]
        const ratings = this.reverseMode ? (byCountry || byService || {}) : (byService || byCountry || {})
        const rating = Number(ratings[operator])

        return Number.isInteger(rating) && rating >= 1 && rating <= 10 ? rating : null
    },

    getOperatorRatingClass(opt, cCode, operator) {
        const rating = this.getOperatorRating(opt, cCode, operator)

        return rating === null ? '' : `order-page-rating-line--rating-${rating}`
    },

    getOperatorSuccessRate(opt, cCode, operator) {
        const rating = this.getOperatorRating(opt, cCode, operator)

        if (rating === null) {
            return null
        }

        return rating === 1 ? 100 : Math.max(0, 100 - rating * 10)
    },

    // CHANGE
    isExternalAmountOperator(operator, cCode = false) {
        const operatorCountry = getExternalAmountOperatorCountry(operator)

        if (!operatorCountry) {
            return false
        }

        return !cCode || operatorCountry === cCode
    },

    getExternalOperatorsAmount(opt, cCode) {
        const operators = this.getAmountOperators(opt, cCode)
        const externalOperators = []

        for (const operator in operators) {
            if (
                Object.prototype.hasOwnProperty.call(operators, operator) &&
                this.isExternalAmountOperator(operator, cCode) &&
                operators[operator] > 0 &&
                this.isPriceAvailable(opt, cCode, operator)
            ) {
                externalOperators.push({
                    operator,
                    amount: operators[operator],
                    rating: this.getOperatorRating(opt, cCode, operator)
                })
            }
        }

        externalOperators.sort((a, b) => {
            const ratingA = a.rating === null ? Number.MAX_SAFE_INTEGER : a.rating
            const ratingB = b.rating === null ? Number.MAX_SAFE_INTEGER : b.rating

            if (ratingA !== ratingB) {
                return ratingA - ratingB
            }

            return a.operator.localeCompare(b.operator)
        })

        return externalOperators.reduce((result, item) => {
            result[item.operator] = item.amount
            return result
        }, {})
    },

    getExternalOperatorName(operator, cCode = false) {
        if (!this.isExternalAmountOperator(operator, cCode)) {
            return this.operatorNameWithoutSuffix(operator)
        }

        const directMatch = operator.match(/^Donor([^_]*)_[A-Z]{2}$/)
        if (directMatch) {
            return directMatch[1] || operator.replace(/_[A-Z]{2}$/, '')
        }

        return operator.split('_Donor')[0]
    },

    getOperatorPublicName(operator, cCode = false) {
        if (this.isExternalAmountOperator(operator, cCode)) {
            return this.getExternalOperatorName(operator, cCode)
        }

        return this.operatorNameWithoutSuffix(operator)
    },
    // END CHANGE

    additTextFromPrice(opt, cCode) {
        if (!opt || !cCode) {
            return false
        }

        if (this.isShowAnyOperator(opt, cCode)) return false

        const operators = this.getAmountOperators(opt, cCode)

        if (!operators || Object.keys(operators).length <= 0) {
            return false
        }

        const availableOperator = []

        for (const key in operators) {
            if (operators[key] && operators[key] > 0 && key != 'Total_' + cCode) {
                availableOperator.push(operators[key])
            }
        }

        return availableOperator.length > 1
    },

    getAvailableCountOperators(opt, cCode, operator = false, hideDeonor = false) {
        if (!opt || !cCode) {
            return 0
        }

        let availableCount = 0

        if (this.amountByCountry && this.amountByCountry[cCode] && this.amountByCountry[cCode][opt]) {
            for (const key in this.amountByCountry[cCode][opt]) {

                if (key && this.isExternalAmountOperator(key, cCode) && hideDeonor) {
                    continue;
                }

                if (this.amountByCountry[cCode][opt].hasOwnProperty(key) && operator && operator == key) {
                    return this.amountByCountry[cCode][opt][key]
                }

                if (this.amountByCountry[cCode][opt][key] && this.amountByCountry[cCode][opt][key] > 0 && key != 'Total_' + cCode) {
                    availableCount += this.amountByCountry[cCode][opt][key]
                }
            }
        } else if (this.amountByService && this.amountByService[opt] && this.amountByService[opt][cCode]) {
            for (const key in this.amountByService[opt][cCode]) {

                if (key && this.isExternalAmountOperator(key, cCode) && hideDeonor) {
                    continue;
                }

                if (this.amountByService[opt][cCode].hasOwnProperty(key) && operator && operator == key) {
                    return this.amountByService[opt][cCode][key]
                }

                if (this.amountByService[opt][cCode][key] && this.amountByService[opt][cCode][key] > 0 && key != 'Total_' + cCode) {
                    availableCount += this.amountByService[opt][cCode][key]
                }
            }
        }

        if (operator) {
            return 0
        }

        return availableCount
    },

    getPriceByCountry(country, opt, operator) {
        if (!country || !opt || !operator) return null

        if (!this.pricesByCountry[country] || !this.pricesByCountry[country][opt] || !Object.prototype.hasOwnProperty.call(this.pricesByCountry[country][opt], operator)) {
            return null
        }

        return this.normalizePrice(this.pricesByCountry[country][opt][operator])
    },

    getServicePrice(opt, cCode, operator) {
        if (!opt || !cCode || !operator) return null

        if (!this.pricesByService[opt] || !this.pricesByService[opt][cCode] || !Object.prototype.hasOwnProperty.call(this.pricesByService[opt][cCode], operator)) {
            return null
        }

        return this.normalizePrice(this.pricesByService[opt][cCode][operator])
    },

    filterCountryF() {
        let country = []

        if (!this.showFavorites || this.reverseMode) {
            country = this.allCountries
        } else {
            country = this.allCountries.filter((item) => this.checkFavoritesCountry(item.shortname))
        }

        if (this.filterTextCountry === '') {
            if (this.sortingSave) {
                this.sorting = this.sortingSave
                this.sortingSave = false
            }
            this.filterCountry = country
        } else {
            if (!this.sortingSave) {
                this.sortingSave = this.sorting
            }
            this.sorting = 0
            const option = this.fuseOptions
            option.shouldSort = true
            option.keys = ['title_country', 'shortname', 'url_country_name']
            // While the favourites filter is active, an entered search must still
            // cover the whole catalogue. Keep matching favourites at the top, but
            // do not hide an otherwise matching country.
            const searchCountries = this.showFavorites && !this.reverseMode
                ? this.allCountries
                : country
            const fuse = new Fuse(searchCountries, option)
            const result = fuse.search(this.filterTextCountry)
            const items = []
            if (!result) {
                this.filterCountry = []
                return false
            }
            const availableCountryCodes = new Set(this.filterCountryShortName)
            for (let i = 0; i < result.length; i++) {
                if (availableCountryCodes.has(result[i].item.shortname)) {
                    items.push(result[i].item)
                }
            }
            if (this.showFavorites && !this.reverseMode) {
                const favoriteCountries = []
                const otherCountries = []

                for (let i = 0; i < items.length; i++) {
                    if (this.checkFavoritesCountry(items[i].shortname)) {
                        favoriteCountries.push(items[i])
                    } else {
                        otherCountries.push(items[i])
                    }
                }

                this.filterCountry = favoriteCountries.concat(otherCountries)
            } else {
                this.filterCountry = items
            }
        }
        this.checkCountryF = true
    },

    countryPushP() {
        this.filterCountryShortName = []
        for (let i = 0; i < this.allCountries.length; i++) {
            this.filterCountryShortName.push(this.allCountries[i].shortname.toUpperCase())
        }
    },

    getCountryName(shortname) {
        const country = this.allCountries.find((item) => item.shortname === shortname)
        return country ? country.title_country : shortname
    },

    getService(opt) {
        const service = this.allServices.find((item) => item.service_opt === opt)
        return service || false
    },

    getServiceByUrl(url) {
        const service = this.allServices.find((item) => item.url_service_name === url)
        return service || false
    },

    getCountryBySN(shortname) {
        const country = this.allCountries.find((item) => item.shortname === shortname)
        return country || false
    },

    getCountryByUrl(url) {
        const country = this.allCountries.find((item) => item.url_country_name === url)
        return country || false
    },

    async selectService(opt) {
        this.sendMetrics('selectservice')

        if ((!this.pricesByServiceLoaded || !this.amountByServiceLoaded) && this.currServOpt !== 'min') {
            return false
        }

        if (this.currServOpt === opt && this.currServOpt !== 'min') {
            this.currServOpt = 'min'
        } else {
            this.currServOpt = opt
        }

        /* PostHog disabled
        try {
            window.ph('service_selected', {
                service_opt: opt,
                service_name: this.getService(opt)?.service_name || null,
                auth_state: this.isUserLoggedIn ? 'authenticated' : 'anonymous'
            })
        } catch (e) {
            console.error(e)
        }
        */
    },

    countrySelection(country) {
        if (country != this.currentCountry) {
            this.currentCountry = country
            /* PostHog disabled
            try {
                window.ph('country_selected', {
                    country: country,
                    country_name: this.getCountryName(country),
                    service_opt: this.currServOpt !== 'min' ? this.currServOpt : null,
                    service_name: this.currServOpt !== 'min' ? this.getService(this.currServOpt)?.service_name : null,
                    auth_state: this.isUserLoggedIn ? 'authenticated' : 'anonymous'
                })
            } catch (e) {
                console.error(e)
            }
            */
        } else {
            this.currentCountry = ''
        }
    },

    sortedList() {
        let sortingPrices = {}
        let calculatedData

        switch (this.sorting) {
            case 0:
                calculatedData = this.filterCountry
                break
            case 1:
                sortingPrices = this.currServOpt != 'min' && this.pricesByService.hasOwnProperty(this.currServOpt) && this.pricesByService[this.currServOpt]
                    ? this.pricesByService[this.currServOpt]
                    : this.minPrices

                calculatedData = this.filterCountry.slice(0).sort((d1, d2) => {
                    if (this.currServOpt == 'min') {
                        if (!sortingPrices.hasOwnProperty(d1.shortname)) return -1
                        if (!sortingPrices.hasOwnProperty(d2.shortname)) return 1
                        return parseFloat(sortingPrices[d1.shortname]) > parseFloat(sortingPrices[d2.shortname]) ? 1 : -1
                    }

                    if (!d1.shortname || !this.getCheapestOperator(this.currServOpt, d1.shortname)) return -1
                    if (!d2.shortname || !this.getCheapestOperator(this.currServOpt, d2.shortname)) return 1
                    return this.getCheapestOperator(this.currServOpt, d1.shortname) > this.getCheapestOperator(this.currServOpt, d2.shortname) ? 1 : -1
                })
                break
            case 2:
                sortingPrices = this.currServOpt != 'min' && this.pricesByService.hasOwnProperty(this.currServOpt) && this.pricesByService[this.currServOpt]
                    ? this.pricesByService[this.currServOpt]
                    : this.minPrices

                calculatedData = this.filterCountry.slice(0).sort((d1, d2) => {
                    if (this.currServOpt == 'min') {
                        if (!sortingPrices.hasOwnProperty(d2.shortname)) return -1
                        if (!sortingPrices.hasOwnProperty(d1.shortname)) return 1
                        return parseFloat(sortingPrices[d1.shortname]) < parseFloat(sortingPrices[d2.shortname]) ? 1 : -1
                    }

                    if (!d2.shortname || !this.getCheapestOperator(this.currServOpt, d2.shortname)) return -1
                    if (!d1.shortname || !this.getCheapestOperator(this.currServOpt, d1.shortname)) return 1
                    return this.getCheapestOperator(this.currServOpt, d1.shortname) < this.getCheapestOperator(this.currServOpt, d2.shortname) ? 1 : -1
                })
                break
            case 3:
                if (this.currServOpt === 'min' || !this.amountByServiceLoaded) {
                    calculatedData = this.filterCountry
                    break
                }

                if (!this.amountByService.hasOwnProperty(this.currServOpt)) {
                    return -1
                }

                calculatedData = this.filterCountry.slice(0).sort((d1, d2) => {
                    let amountD1 = 0
                    let amountD2 = 0

                    if (!d2 || !d1 || !d2.shortname || !d1.shortname) {
                        return 1
                    }

                    amountD1 = this.getAvailableCountOperators(this.currServOpt, d1.shortname)
                    amountD2 = this.getAvailableCountOperators(this.currServOpt, d2.shortname)

                    return amountD1 < amountD2 ? 1 : -1
                })
                break
            case 4:
                if (this.currServOpt === 'min' || !this.amountByServiceLoaded) {
                    calculatedData = this.filterCountry
                    break
                }

                if (!this.conversationsByService.hasOwnProperty(this.currServOpt)) {
                    return 1
                }

                const convers = this.conversationsByService[this.currServOpt]

                calculatedData = this.filterCountry.slice(0).sort((d1, d2) => {
                    if (!convers.hasOwnProperty(d1.shortname)) {
                        return 1
                    }

                    if (!convers.hasOwnProperty(d2.shortname)) {
                        return -1
                    }

                    return convers[d1.shortname] < convers[d2.shortname] ? 1 : -1
                })
                break
            default:
                calculatedData = this.filterCountry
                break
        }

        return calculatedData
    },

    sortedServices() {
        let arrServices = this.allServices

        const showFavoriteServicesOnly = this.reverseMode && this.showFavoritesServices

        if (showFavoriteServicesOnly) {
            if (!this.favoritesService || this.favoritesService.length <= 0) {
                return this.allServices
            }

            const favoriteServices = []

            for (let i = 0; i < this.favoritesService.length; i++) {
                const service = this.getService(this.favoritesService[i])
                if (service) {
                    favoriteServices.push(service)
                }
            }

            arrServices = favoriteServices
        }

        if (this.serviceSearch === '') {
            return arrServices
        }

        const option = this.fuseOptions
        option.shouldSort = true
        option.keys = ['url_service_name', 'service_name', 'service_opt']
        // Keep the no-search state as "favourites only". Once the user searches,
        // search all services and place matched favourites before other matches.
        const searchServices = showFavoriteServicesOnly ? this.allServices : arrServices
        const fuse = new Fuse(searchServices, option)
        const result = fuse.search(this.serviceSearch)
        const items = []

        if (!result.length) {
            return items
        }

        const checkSearchedServ = this.checkSearchedText(this.serviceSearch)
        const matchedServiceOpts = new Set(result.map((item) => item.item.service_opt))
        const haveOther = matchedServiceOpts.has('opt19')

        for (let i = 0; i < searchServices.length; i++) {
            const searchEl = matchedServiceOpts.has(searchServices[i].service_opt)
            if (searchEl && searchServices[i].service_opt != 'opt4') {
                items.push(searchServices[i])
            }
            if (searchServices[i].service_opt == 'opt4' && checkSearchedServ) {
                items.unshift(searchServices[i])
            }

            if (searchServices[i].service_opt == 'opt84' && this.serviceSearch && this.serviceSearch.toLowerCase() == 'pof') {
                items.unshift(searchServices[i])
            }

        }

        if (!haveOther) {
            items.push({
                service_name: 'OTHER (no guarantee)',
                service_opt: 'opt19',
                id: '179',
                image_service_path: 'images/ico/another.png',
            })
        }

        if (!showFavoriteServicesOnly) {
            return items
        }

        const favoriteItems = []
        const otherItems = []

        for (let i = 0; i < items.length; i++) {
            if (this.checkFavoritesService(items[i].service_opt)) {
                favoriteItems.push(items[i])
            } else {
                otherItems.push(items[i])
            }
        }

        return favoriteItems.concat(otherItems)
    },
}
